import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import { ContactInfo } from "../"

const AboutContact = ( { intl } ) => (
  <div className="block text contact">
    <label className="label">{ intl.formatMessage( { id: "about.contact.label" } ) }</label>
    <div className="content">
      <ContactInfo />
    </div>
  </div>
)

const inject = injectIntl( AboutContact )
export { inject as AboutContact }
